export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-dispatch/index.js
// module id = 9kPv
// module chunks = 0